export default __webpack_public_path__ + "media/images/features/local_delivery/episode3/LP_01-64eb52e9185a2486a2a45e7bf5f60d23.jpg";